import { HandleTextChange, HandleCheckChange, RadioHandler, CallAPI, parseIntFromStr, GetCookieFunction } from './../../utils/util';
import React, { Component } from "react";
import {useLocation, useNavigate, useParams, useSearchParams} from "react-router-dom";
import { PatientNav } from './patientnav';
import { FunnelNav } from './funnelNav';
import Alert from 'react-bootstrap/Alert';
import dateFormat from 'dateformat';
import VoiceInput from '../../utils/VoiceInput';

function withRouter(Component) {
  function ComponentWithRouterProp(props) {
      let location = useLocation();
      let navigate = useNavigate();
      let params = useParams();
      let [searchParams] = useSearchParams();

      return (
          <Component
              {...props}
              router={{ location, navigate, params, searchParams }}
          />
      );
  }
  return ComponentWithRouterProp;
}

class PatientInfo extends Component {
    constructor(props) {
        super(props);
        this.patientId = parseIntFromStr(this.props.router.params.patientId);
        this.userType = GetCookieFunction("User").type;
        this.state = {
            "Risk_Bond_Signed": false,
            "Referring_Physician_Id": null,
            "Referral_FName": "",
            "Referral_LName": "",
            "Referral_Phone": "",
            "BGroup": "",
            "Income": null,
            "RegistrationDate": dateFormat(new Date(), "yyyy-mm-dd"),
            "Hepatitis": "0",
            "DateHospitalized": "",
            "TransplantYear": "",
            "AbleToWork": false,
            "SeeksFinAssistance": false,
            "ZakatEligible": false,
            "HistoryOfIllness": "",
            "NextKinName": "",
            "NextKinPhone": "",
            "sameAsPatientPhone": false,
            "Patient_ID": this.props.router.params.patientId,
            "LastModified": null,
            "Staff_FName": "",
            "Staff_LName": "",
            "physicianSuggestions": [],
            "showSuggestions": false,
            "showAddModal": false,
            "newPhysician": { firstName: '', lastName: '', phone: '' },
            "addModalError": ""
        };

        // Is this page being access as a funnel mode?
        this.funnel = this.props.router.searchParams.get('funnel') ? "?funnel=1" : "";

        this.handleTextChange = HandleTextChange.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
        this.handleCheckChange = HandleCheckChange.bind(this);
        this.radioHandler = RadioHandler.bind(this);
        this.handleReferralFNameChange = this.handleReferralFNameChange.bind(this);
        this.selectPhysician = this.selectPhysician.bind(this);
    }

    componentDidMount() {
      CallAPI({}, `patients/${this.state.Patient_ID}/patientInfo`, 'GET', (res) => {
          
          if (!res){
              console.log("No results found");    // Should not happen.
          } else {
              // Format the registration date as yyyy-mm-dd for the <input type="date">.
              // Format the Date object directly — do NOT round-trip through a locale
              // string, since toLocaleString() is browser-locale dependent (e.g. dd/mm/yyyy)
              // and re-parsing that produces an "Invalid Date" in non-US locales.
              let resDate = res.RegistrationDate ? new Date(res.RegistrationDate) : new Date();
              res.RegistrationDate = dateFormat(resDate, "yyyy-mm-dd")

              this.setState(res);
              
          }
      }, (message) => {
          this.setState({
              "modalVariant": "danger",
              "modalMessage": "Error loading patient data: " + message.message
          })
      });
  }

    handleReferralFNameChange(e) {
        const value = e.target.value;
        this.setState({ "Referral_FName": value });

        if (value.length >= 2) {
            CallAPI({}, `referringPhysicians?search=${encodeURIComponent(value)}`, 'GET', (res) => {
                this.setState({
                    "physicianSuggestions": res.data || [],
                    "showSuggestions": true
                });
            });
        } else {
            this.setState({ "physicianSuggestions": [], "showSuggestions": false });
        }
    }

    selectPhysician(physician) {
        this.setState({
            "Referring_Physician_Id": physician.id,
            "Referral_FName": physician.firstName,
            "Referral_LName": physician.lastName,
            "Referral_Phone": physician.phone || "",
            "physicianSuggestions": [],
            "showSuggestions": false
        });
    }

    openAddModal = () => {
        this.setState({
            showAddModal: true,
            showSuggestions: false,
            newPhysician: { firstName: this.state.Referral_FName, lastName: '', phone: '' },
            addModalError: ''
        });
    }

    closeAddModal = () => {
        this.setState({ showAddModal: false, addModalError: '' });
    }

    handleNewPhysicianChange = (e) => {
        const { name, value } = e.target;
        this.setState(prev => ({
            newPhysician: { ...prev.newPhysician, [name]: value }
        }));
    }

    handleSameAsPatientPhone = (e) => {
        if (e.target.checked) {
            this.setState({ sameAsPatientPhone: true });
            CallAPI({}, `patients/${this.patientId}/basic`, 'GET', (res) => {
                if (res && res.pNum) {
                    this.setState({ NextKinPhone: res.pNum });
                }
            });
        } else {
            this.setState({ NextKinPhone: '', sameAsPatientPhone: false });
        }
    }

    saveNewPhysician = (e) => {
        e.preventDefault();
        const { firstName, lastName, phone } = this.state.newPhysician;

        CallAPI({ firstName, lastName, phone }, 'referringPhysicians', 'POST', (res) => {
            if (res.success) {
                this.setState({
                    showAddModal: false,
                    addModalError: '',
                    Referring_Physician_Id: res.data.id,
                    Referral_FName: res.data.firstName,
                    Referral_LName: res.data.lastName,
                    Referral_Phone: res.data.phone
                });
            } else {
                this.setState({ addModalError: res.message || "This physician already exists" });
            }
        }, () => {
            this.setState({ addModalError: "Failed to save. Please try again." });
        });
    }

    handleSubmit(event) {
        event.preventDefault();

        CallAPI(this.state, `patients/${this.patientId}/patientInfo`, 'POST', (res) => {
          if (res && res[0].success) {
            if (this.funnel && (this.userType === "doctor" || this.userType === "nurse")){
                this.props.router.navigate("/patients/"+this.state.Patient_ID+"/pastMedicalHistory"+this.funnel);
            } else if (this.funnel) {
                this.setState({
                    "modalVariant": "success",
                    "modalMessage": "The patient registration data is successfully saved. Only a doctor or a nurse can access the remainder of the registration forms."
                });
            } else {
                this.setState({
                    "modalVariant": "success",
                    "modalMessage": "Patient history has been saved."
                });
            }
          } else {
            this.setState({
              "modalVariant": "danger",
              "modalMessage": "Failed to save patient info: " + ((res && res[0]) ? res[0].message : "")
          });
          }
        }, 
        (message) => {
          this.setState({
              "modalVariant": "danger",
              "modalMessage": "Patient history could not be saved."
          })
      });
    }

    render = () => {
        const r = (e) => this.radioHandler(e);
        const bloodGroups = ["O-","O+","B-","B+","A-","A+","AB-","AB+","UNKNOWN"];

        return (
            <div>
                <PatientNav patientId={this.patientId} />

                <div className="ci-page">
                    {this.funnel && <FunnelNav patientId={this.patientId} currentStep={1} />}
                    <div className="ci-header">
                        <h2>Patient Info</h2>
                        <p>Registration details and medical background</p>
                        {this.state.LastModified && this.state.Staff_FName && (
                            <p style={{fontSize: '0.85rem', color: 'var(--text-muted)', marginTop: '4px'}}>
                                Last updated by {this.state.Staff_FName} {this.state.Staff_LName} on {new Date(this.state.LastModified).toLocaleString(undefined, {
                                    year: 'numeric', month: 'short', day: 'numeric',
                                    hour: '2-digit', minute: '2-digit',
                                    timeZone: GetCookieFunction("User").tz
                                })}
                            </p>
                        )}
                    </div>

                    {this.state.modalVariant && (
                        <Alert variant={this.state.modalVariant} className="ci-alert">
                            {this.state.modalMessage}
                        </Alert>
                    )}

                    <form onSubmit={(e) => this.handleSubmit(e)}>

                        {/* ── Risk Bond ── */}
                        <div className="ci-section-title">Risk Bond</div>
                        <div className="ci-card">
                            <div className="ci-checkbox-row">
                                <label className="ci-checkbox-label">
                                    <input type="checkbox" name="Risk_Bond_Signed"
                                        checked={this.state.Risk_Bond_Signed}
                                        onChange={(e) => this.handleCheckChange(e)} />
                                    <span>Risk Bond is signed and a copy is stored in our records</span>
                                </label>
                            </div>
                        </div>

                        {/* ── Referral Doctor ── */}
                        <div className="ci-section-title">Referral Doctor</div>
                        <div className="ci-card">
                            <div className="ci-grid">
                                <div className="ci-field ci-field-autocomplete">
                                    <label htmlFor="Referral_FName">First Name</label>
                                    <input type="text" id="Referral_FName" name="Referral_FName"
                                        maxLength="32" placeholder="First name"
                                        autoComplete="off"
                                        value={this.state.Referral_FName}
                                        onChange={(e) => this.handleReferralFNameChange(e)}
                                        onBlur={() => setTimeout(() => this.setState({ showSuggestions: false }), 200)} />
                                    {this.state.showSuggestions && (
                                        <ul className="ci-autocomplete-list">
                                            {this.state.physicianSuggestions.length > 0 ? (
                                                this.state.physicianSuggestions.map((p) => (
                                                    <li key={p.id} className="ci-autocomplete-item"
                                                        onMouseDown={() => this.selectPhysician(p)}>
                                                        {p.firstName} {p.lastName} {p.phone ? `— ${p.phone}` : ""}
                                                    </li>
                                                ))
                                            ) : (
                                                <li className="ci-autocomplete-item ci-autocomplete-add"
                                                    onMouseDown={this.openAddModal}>
                                                    + Add new referring doctor
                                                </li>
                                            )}
                                        </ul>
                                    )}
                                </div>
                                <div className="ci-field">
                                    <label htmlFor="Referral_LName">Last Name</label>
                                    <input type="text" id="Referral_LName" name="Referral_LName"
                                        maxLength="32" placeholder="Last name"
                                        value={this.state.Referral_LName}
                                        readOnly />
                                </div>
                                <div className="ci-field">
                                    <label htmlFor="Referral_Phone">Phone Number</label>
                                    <input type="tel" id="Referral_Phone" name="Referral_Phone"
                                        maxLength="20"
                                        value={this.state.Referral_Phone}
                                        readOnly />
                                </div>
                            </div>
                        </div>

                        {/* ── Next of Kin ── */}
                        <div className="ci-section-title">Next of Kin</div>
                        <div className="ci-card">
                            <div className="ci-grid ci-grid-2">
                                <div className="ci-field">
                                    <label htmlFor="NextKinName">Full Name</label>
                                    <input type="text" id="NextKinName" name="NextKinName"
                                        maxLength="64" placeholder="Full name"
                                        value={this.state.NextKinName}
                                        onChange={(e) => this.handleTextChange(e)} />
                                </div>
                                <div className="ci-field">
                                    <label htmlFor="NextKinPhone">Phone Number</label>
                                    <input type="tel" id="NextKinPhone" name="NextKinPhone"
                                        maxLength="20" placeholder="e.g. 01054 694200"
                                        pattern="^\+?[\d\s\(\)\-]+\d{4}$"
                                        title="e.g. 01054 694200 or +880 1054 694200"
                                        value={this.state.NextKinPhone}
                                        onChange={(e) => { this.handleTextChange(e); this.setState({ sameAsPatientPhone: false }); }} />
                                    <label className="ci-checkbox-label ci-inline-checkbox">
                                        <input type="checkbox" checked={this.state.sameAsPatientPhone} onChange={this.handleSameAsPatientPhone} />
                                        <span>Same as patient's</span>
                                    </label>
                                </div>
                            </div>
                        </div>

                        {/* ── Blood Type ── */}
                        <div className="ci-section-title">Medical Details</div>
                        <div className="ci-card">
                            <div className="ci-card-label ci-required-label">Blood Type</div>
                            <div className="ci-radio-group">
                                {bloodGroups.map((bg, i) => (
                                    <label key={i} className="ci-radio-option">
                                        <input type="radio" id={`BGroup${i}`} name="BGroup" value={bg}
                                            required={i === 0}
                                            checked={this.state.BGroup === bg}
                                            onChange={r} />
                                        <span>{bg === "UNKNOWN" ? "Unknown" : bg}</span>
                                    </label>
                                ))}
                            </div>
                        </div>

                        {/* ── Dates & Financials ── */}
                        <div className="ci-card">
                            <div className="ci-grid">
                                <div className="ci-field">
                                    <label htmlFor="Income">Monthly Income</label>
                                    <input type="number" id="Income" name="Income"
                                        placeholder="Amount"
                                        value={this.state.Income ?? ""}
                                        onChange={(e) => this.handleTextChange(e)} />
                                </div>
                                <div className="ci-field">
                                    <label htmlFor="RegistrationDate">Registration Date</label>
                                    <input type="date" id="RegistrationDate" name="RegistrationDate"
                                        value={this.state.RegistrationDate}
                                        onChange={(e) => this.handleTextChange(e)} />
                                </div>
                                <div className="ci-field">
                                    <label htmlFor="TransplantYear">Transplant Year</label>
                                    <input type="text" id="TransplantYear" name="TransplantYear"
                                        maxLength="4" pattern="[\d]{4}"
                                        title="4-digit year e.g. 1986"
                                        placeholder="e.g. 1986"
                                        value={this.state.TransplantYear ?? ""}
                                        onChange={(e) => this.handleTextChange(e)} />
                                </div>
                            </div>
                        </div>

                        {/* ── Checkboxes ── */}
                        <div className="ci-card">
                            <div className="ci-card-label">Financial &amp; Social Status</div>
                            <div className="ci-checkbox-row">
                                <label className="ci-checkbox-label">
                                    <input type="checkbox" name="AbleToWork"
                                        checked={this.state.AbleToWork}
                                        onChange={(e) => this.handleCheckChange(e)} />
                                    <span>Employed / Able to Work</span>
                                </label>
                                <label className="ci-checkbox-label">
                                    <input type="checkbox" name="SeeksFinAssistance"
                                        checked={this.state.SeeksFinAssistance}
                                        onChange={(e) => this.handleCheckChange(e)} />
                                    <span>Seeking Financial Assistance</span>
                                </label>
                                <label className="ci-checkbox-label">
                                    <input type="checkbox" name="ZakatEligible"
                                        checked={this.state.ZakatEligible}
                                        onChange={(e) => this.handleCheckChange(e)} />
                                    <span>Eligible for Zakah</span>
                                </label>
                            </div>
                        </div>

                        {/* ── History of Illness ── */}
                        <div className="ci-card">
                            <div className="ci-field">
                                <label htmlFor="HistoryOfIllness">History of Present Illness</label>
                                <div className="ci-field-with-voice">
                                    <textarea id="HistoryOfIllness" name="HistoryOfIllness"
                                        maxLength="1024" rows={4}
                                        placeholder="Describe the patient's history of present illness..."
                                        value={this.state.HistoryOfIllness}
                                        onChange={(e) => this.handleTextChange(e)} />
                                    <VoiceInput language="en" onTranscript={(text) => {
                                        this.setState(prev => ({
                                            HistoryOfIllness: (prev.HistoryOfIllness || "") + (prev.HistoryOfIllness ? " " : "") + text
                                        }));
                                    }} />
                                </div>
                            </div>
                        </div>

                        <div className="ci-submit-row">
                            <button type="submit" className="logSubmit ci-submit-btn">Save Patient Info</button>
                        </div>

                    </form>
                </div>

                {/* ── Add Physician Modal ── */}
                {this.state.showAddModal && (
                    <div className="ci-modal-overlay" onClick={this.closeAddModal}>
                        <div className="ci-modal" onClick={(e) => e.stopPropagation()}>
                            <h3>Add New Referring Doctor</h3>
                            {this.state.addModalError ? (
                                <div>
                                    <p className="ci-modal-error">{this.state.addModalError}</p>
                                    <div className="ci-submit-row">
                                        <button type="button" className="logSubmit ci-submit-btn" onClick={this.closeAddModal}>Close</button>
                                    </div>
                                </div>
                            ) : (
                                <form onSubmit={this.saveNewPhysician}>
                                    <div className="ci-field">
                                        <label className="ci-required-label">First Name</label>
                                        <input type="text" name="firstName" required maxLength="32"
                                            value={this.state.newPhysician.firstName}
                                            onChange={this.handleNewPhysicianChange} />
                                    </div>
                                    <div className="ci-field">
                                        <label className="ci-required-label">Last Name</label>
                                        <input type="text" name="lastName" required maxLength="32"
                                            value={this.state.newPhysician.lastName}
                                            onChange={this.handleNewPhysicianChange} />
                                    </div>
                                    <div className="ci-field">
                                        <label>Phone Number</label>
                                        <input type="tel" name="phone" maxLength="20"
                                            placeholder="e.g. 01054 694200"
                                            value={this.state.newPhysician.phone}
                                            onChange={this.handleNewPhysicianChange} />
                                    </div>
                                    <div className="ci-submit-row">
                                        <button type="button" className="ci-modal-icon-btn ci-modal-cancel" onClick={this.closeAddModal} title="Cancel">✕</button>
                                        <button type="submit" className="ci-modal-icon-btn ci-modal-save" title="Save">✓</button>
                                    </div>
                                </form>
                            )}
                        </div>
                    </div>
                )}
            </div>
        );
    };
}

export default withRouter(PatientInfo)